export function isHowItWorksVisible(
  dismissed: boolean,
  isMember: boolean,
  confirmedBookingsCount?: number | null
): boolean {
  return (
    !dismissed && (!isMember || (confirmedBookingsCount != null && confirmedBookingsCount < 2))
  );
}

export function getHowItWorksInitScript(storageKey: string): string {
  // Keep the pre-paint decision identical to React's audience rule without loading the app bundle.
  return `(() => {
    let visible = false;
    try {
      const dismissed = JSON.parse(localStorage.getItem(${JSON.stringify(storageKey)}) || 'null') === 'closed';
      const auth = JSON.parse(localStorage.getItem('user') || 'null');
      const user = auth && auth.user;
      visible = (${isHowItWorksVisible.toString()})(dismissed, !!user, user && user.confirmedBookingsCount);
    } catch (_) {}
    document.documentElement.setAttribute('data-how-it-works', visible ? 'show' : 'hide');
  })();`;
}
